/**
 * composer-v2/lib/urlMatchers — AutoLinkPlugin matcher used by V2 composer
 * to turn bare URLs into LinkNodes on type. KAP-304.
 *
 * Pattern matches `http(s)://` and `www.`-prefixed forms. Bare-domain
 * matches without a scheme are normalized to `https://` for the link
 * href so the resulting markdown is well-formed and reader-side
 * `MarkdownRenderer` produces a clickable anchor.
 */

const URL_REGEX = /(?:https?:\/\/(?:www\.)?|www\.)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}\b(?:[-a-zA-Z0-9@:%_+.~#?&/=]*)/i;

export function urlMatcher(text) {
  const match = URL_REGEX.exec(text);
  if (!match) return null;
  const fullMatch = match[0];
  return {
    index: match.index,
    length: fullMatch.length,
    text: fullMatch,
    url: fullMatch.startsWith('http') ? fullMatch : `https://${fullMatch}`
  };
}

export const URL_MATCHERS = [urlMatcher];
